/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsOilTank: {
  name: 'oil-tank';
  data: string;
} = {
  name: 'oil-tank',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v9.98a.97.97 0 0 1 0 .042V19a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5.98a.97.97 0 0 1 0-.042V5Zm2 9.618V19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.382l-1.447-.724a3.473 3.473 0 0 0-3.106 0c-1.54.77-3.354.77-4.894 0L7 14.618Zm10-1.236-.553-.276a5.472 5.472 0 0 0-4.894 0 3.473 3.473 0 0 1-3.106 0L7 12.382V7.829c.313.11.65.171 1 .171h8c.35 0 .687-.06 1-.17v5.552ZM16 4a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h8Z" fill="currentColor"/></svg>`,
};
